import AxiosFunctions from './axiosFunctions'

/** APIs Trafigura: mismo contrato que apiList pero contra /api/trafigura (Laravel routes/trafiguraRoutes.php). */
const uri = {
    getRolesUri: '/trafigura/roles',
    getPermisosUri: '/trafigura/permisos',
    savePermisosUri: '/trafigura/permisos/asignar-desasignar'
}

export default {
    getRoles: async (params = {}) => {
        const query = new URLSearchParams(params).toString();
        return await AxiosFunctions.get(uri.getRolesUri + (query ? "?" + query : ""));
    },

    saveRoles: async (data) => {
        return await AxiosFunctions.post(uri.getRolesUri, data);
    },

    editRoles: async (data) => {
        let id = data[0];
        let params = { name: data[1], guard_name: data[2] };
        if (data[3] != null) params.cliente_plataforma_id = data[3];
        return await AxiosFunctions.patch(uri.getRolesUri + '/' + id, params);
    },

    deleteRoles: async (id) => {
        return await AxiosFunctions.delete(uri.getRolesUri + '/' + id, {});
    },

    getPermisos: async (id, params = {}) => {
        const query = new URLSearchParams(
            Object.fromEntries(
                Object.entries(params).filter(([, v]) => v != null && v !== "")
            )
        ).toString();
        return await AxiosFunctions.get(
            uri.getPermisosUri + "/" + id + (query ? "?" + query : "")
        );
    },

    savePermisos: async (data) => {
        return await AxiosFunctions.post(uri.savePermisosUri, data);
    },
}
